<template lang="pug">
.d-flex.align-center.px-6.py-4(ref="filters")
  search(
    v-model="model.filters.search"
    @onFocusToggle="searchFocused = $event"
    @change="setQuery"
    @onClear="setQuery"
  ).search.pr-3
  v-select(
    v-show="!searchFocused"
    item-value="query"
    item-text="name"
    v-model="model.filters.license_type"
    clearable
    solo
    dense
    flat
    menu-props="offset-y"
    :items="model.options.license_types.list"
    @change="setQuery"
    label="License type"
  ).filter
  v-select(
    v-show="!searchFocused && layoutVal !== 'content' && layoutVal !== 'video'"
    item-value="query"
    item-text="name"
    v-model="model.filters.type"
    clearable
    solo
    dense
    flat
    menu-props="offset-y"
    :items="types"
    @change="setQuery"
    label="Type"
  ).filter
  v-select(
    v-show="!searchFocused"
    item-value="id"
    item-text="name"
    v-model="model.filters.category"
    clearable
    multiple
    solo
    dense
    flat
    menu-props="offset-y"
    :items="model.options.categories.list"
    :loading="model.options.categories.loading"
    :disabled="model.options.categories.loading"
    @change="setQuery"
    label="All Categories"
  ).filter
  v-select(
    v-show="false"
    item-value="query"
    item-text="name"
    v-model="model.filters.layout"
    multiple
    solo
    dense
    flat
    menu-props="offset-y"
    :items="model.options.layouts.list"
    :loading="model.options.layouts.loading"
    :disabled="model.options.layouts.loading"
    @change="setQuery"
    label="All Layouts"
  ).filter
  //div(v-show="layoutVal !== 'content' && layoutVal !== 'video'")
  div
    v-icon(@click="toggleView" v-if="viewList") mdi-view-grid
    v-icon(@click="toggleView" v-else) mdi-view-list
</template>

<script>
import FiltersModel from "../core/models/trainingFiltersModel.js"
import EventBus from "@/util/event-bus";

export default {
  props: {
    layoutVal: [String, Array]
  },
  data: () => ({
    model: {},
    types: [
      {
        query: 'GEVAARHERKENNING',
        name: 'Gevaarherkenning'
      },
      {
        query: 'KENNIS',
        name: 'Kennis'
      },
      {
        query: 'INZICHT',
        name: 'Inzicht'
      }
    ],
    searchFocused: false,
    viewList: true,
  }),

  watch: {
    layoutVal(val) {
      this.model.filters.layout = val;
      this.setQuery();
    }
  },

  created() {
    this.initFilters()
  },

  components: {
    search: () => import("@/components/global/Search.vue"),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
  },
  methods: {
    initFilters() {
      this.model = new FiltersModel(this.$route.query)
    },

    async loadOptions() {
      await this.model.loadFilterOptions(this.$store)
    },

    async setQuery() {
      try {
        await this.$router.replace({query: { ...this.$route.query, ...this.model.getApiData()}})
      } catch (e) {
        console.log(e)
      }
      this.$emit('filterChanged')
    },

    toggleView() {
      this.viewList = !this.viewList
      EventBus.$emit('toggleView', this.viewList)
    },
  }
}
</script>
<style lang="scss" scoped>
  .search::v-deep {
    .v-input__slot{
      &:before {
        display: none;
      }
    }
  }
  .filter {
    flex: 0 1 220px;
  }
  .v-input::v-deep {
    .v-input__slot {
      margin: 0;
    }
    .v-input__control {
      min-height: auto!important;
    }
    .v-text-field__details {
      display: none;
    }
  }
</style>
